module.exports = __webpack_public_path__ + "img/real.806b37b7.png";